import { Model } from '@vuex-orm/core'
import Vue from 'vue'
import { defaultDate } from '../utils/helper'

export default class ErrorModel extends Model {
  static entity = 'error'

  static fields () {
    return {
      errText: this.string(''),
      errState: this.boolean(false)
    }
  }

  /**
   *
   * @type {{errState: boolean, errText: string}}
   */
  static defaultValue = {
    errText: '',
    errState: false
  }
}